import React from 'react';
import { Link } from 'react-router-dom';

export default function BladeLayout({ menu, selectedKey, onSelect, children, title }) {
  const hasSubMenu = typeof menu === 'object' && menu !== null;
  const shouldHideSidebar = hasSubMenu && Object.keys(menu).length === 1 && Object.keys(menu)[0].toLowerCase() === 'editorial board';

  return (
    <div className="bg-[#FAF9F6] min-h-screen text-gray-800 font-sans pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col lg:flex-row gap-8 items-start">
          {/* Desktop / Tablet Sidebar */}
          {hasSubMenu && !shouldHideSidebar && (
            <aside className="w-full lg:w-72 bg-white rounded-3xl p-6 shadow-sm flex-shrink-0 space-y-4">
              {title && (
                <h3 className="text-xs font-bold uppercase tracking-wider text-[#03478E] px-2 mb-2">
                  {title}
                </h3>
              )}
              <ul className="space-y-1.5">
                {Object.entries(menu).map(([label, value]) => {
                  const isSelected = selectedKey === label;
                  return (
                    <li key={label}>
                      <Link
                        to={`/${value.replace(/^\/+/, '')}`}
                        className={`block px-4 py-2.5 rounded-2xl text-xs sm:text-sm font-semibold transition-all duration-200 ${
                          isSelected
                            ? 'bg-blue-50/80 text-[#03478E] font-bold shadow-2xs'
                            : 'text-gray-600 hover:text-[#03478E] hover:bg-gray-50'
                        }`}
                      >
                        {label}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </aside>
          )}

          {/* Main Content Area */}
          <div className="flex-1 w-full min-w-0">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}